export default __webpack_public_path__ + "static/media/overspeed.9c200529.png";